import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconV1 } from 'common/icon/iconV1.js';
import { LinkFactoryReactRouter } from 'common/link/link-react-router.js';
import { ArrowContainer, PopoverState } from 'react-tiny-popover';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { PW_FAVOURITE_LIST } from 'utilities/consts/variable-types.js';
import { trackNavigateEvent } from 'utilities/posthog-tracking.js';
import { SearchbarFavouriteLocationBody } from '../searchbar-fav-location-body.js';
import { getFavouriteLocationIcon } from '../searchbar-fav-location-icon.js';

interface ISearchBarFavouriteContentProps {
  topFavourites: ILocationSummary[];
  favouriteTopItems: ILocationSummary[];
  dropdownClicked: () => void;
  favouriteBottomItems: ILocationSummary[];
}

/** Content of manage-favourites */
export const FavPopupContentManageFavs = ({
  topFavourites,
  favouriteTopItems,
  dropdownClicked,
  favouriteBottomItems,
  childRect,
  popoverRect,
}: ISearchBarFavouriteContentProps & Pick<PopoverState, 'childRect' | 'popoverRect' | 'position'>) => {
  return (
    <ArrowContainer
      position={'bottom'}
      childRect={childRect}
      arrowSize={8}
      popoverRect={popoverRect}
      arrowColor="white"
    >
      <ul className="SearchBar-favourites-dropdown-target" data-testid={PW_FAVOURITE_LIST}>
        {topFavourites.map((fav, idx) => {
          const { key, link, value } = fav;

          if (link) {
            const iconName = getFavouriteLocationIcon(fav);

            // Hide the top three in the favourites drop down on larger screens as they appear in the search bar instead
            const isTopThree = favouriteTopItems.some((topItem) => topItem.key === key);
            const listItemClasses = classNames('SearchBar-favourites-dropdown-target-item', {
              'is-top-three': isTopThree,
              'u-flexJustifyCenter': !value,
            });

            return (
              <li data-module="SearchBarFavouritesContent" className={listItemClasses} key={idx}>
                <LinkFactoryReactRouter href={link.url}>
                  {iconName ? (
                    <IconWithText
                      icon={iconName}
                      classes="IconWithText--vCenter IconWithText--small u-textTruncate u-pR-xs"
                    >
                      <span className="small u-textBold u-block u-textTruncate">{fav.label}</span>
                    </IconWithText>
                  ) : (
                    <span className="small u-textBold u-block u-textTruncate">{fav.label}</span>
                  )}

                  <span className="u-flex u-flexAlignItemsCenter">
                    <SearchbarFavouriteLocationBody favourite={fav} />
                    <IconV1 icon="chevron-right" iconClass="svg--1em" />
                  </span>
                </LinkFactoryReactRouter>
              </li>
            );
          }
          return null;
        })}
        {topFavourites.length === 0 && (
          <li className="u-pT-sm u-pB-sm u-pL-sm u-pR-sm">
            <h3 className="u-mT-0 u-mB-xs">You don’t have any favourites yet</h3>
            <small className="u-block">
              To get started click on the yellow star in the search bar to favourite pages you use often.
            </small>
          </li>
        )}
        <li className="SearchBar-favourites-dropdown-target-footer">
          <LinkFactoryReactRouter
            onClick={() => {
              trackNavigateEvent('favourite_widget', 'manage_favourites_link');
              dropdownClicked();
            }}
            href="/manage-favourites"
            data-fav-count={favouriteTopItems.length + favouriteBottomItems.length}
            className="small u-textBold"
          >
            Manage favourites
          </LinkFactoryReactRouter>
        </li>
      </ul>
    </ArrowContainer>
  );
};
